/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取绑定邮箱的验证码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  bindEmailCaptchaDto: member.BindEmailCaptchaDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/email/captcha`,
    data: bindEmailCaptchaDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
